module.exports = "/b2b11f8d0b8dd266f469e63438ae4f54.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/form-bg.png
 ** module id = 2216
 ** module chunks = 0
 **/